import React from "react";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { RouterProvider } from "react-router-dom";
import ReactDOM from "react-dom";
import { MASBRAN_ROUTES } from "./routes";

ReactDOM.render(<RouterProvider router={MASBRAN_ROUTES} />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
